import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpWrapperService } from '.././http-wrapper.service';
import { IHttpRequestOptions } from '../../interfaces/http-request-option.interface';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  constructor(private httpWrapperService: HttpWrapperService) {}


  uploadFile(formData: FormData, url = `file`, isUserUploadedFile: boolean = false): Observable<string> {
    formData.append('isUserUploadedFile', isUserUploadedFile.toString());
    const options: IHttpRequestOptions = { url: url };
    options.body = formData;
    return this.httpWrapperService.postFromApiGateWay(options).pipe(
        map((response: string) => response)
    );
  }
  convertUrl(blobUrl:string):Observable<string>{
    const url=`file/convert/base64`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = { 
      url: url,
      headers: headers,
      body: {url : blobUrl},
  };

  return this.httpWrapperService.postFromApiGateWay(options).pipe(
    map((response: string) => response)
);
}
  }
